import React, {useState, useRef, useEffect} from 'react'
import {McSwitch} from '@maersk-global/mds-react-wrapper/components-core/mc-switch'
import {EstaticosData} from './CookiesEstaticos'
import styles from '../index.module.scss'
import {McIcon} from '@maersk-global/mds-react-wrapper'

interface Cookie {
  primeiroNome: string
  segundoNome: string
  finalidade: string
  validade: string
  processadorDados: string
  linkPolitica: string
}

const Estatico: React.FC<{
  handleChangeCookie: (cookieName: string, value: boolean) => void
}> = ({handleChangeCookie}) => {
  const [showDetail, setShowDetail] = useState(false)
  const detailsRef = useRef<HTMLDivElement | null>(null)
  const [contentHeight, setContentHeight] = useState(0)

  useEffect(() => {
    if (detailsRef.current) {
      setContentHeight(showDetail ? detailsRef.current.scrollHeight : 0)
    }
  }, [showDetail])

  return (
    <div className={styles.cookie_section}>
      <div className={styles.between}>
        <span>Estáticos</span>
        <McSwitch
          label="ON"
          name="agreement"
          change={(value: boolean) =>
            handleChangeCookie('cookie_cat_statistic', value)
          }
        />
      </div>
      <div className={styles.section_info}>
        Os cookies estatísticos ajudam o proprietário do Web site a compreender
        a forma como os visitantes interagem com o mesmo através da recolha e
        comunicação de informações.
      </div>

      <a className={styles.link} onClick={() => setShowDetail(!showDetail)}>
        Mais detalhes
        <McIcon
          style={{margin: '0 0 0 .25rem'}}
          icon={showDetail ? 'chevron-up' : 'chevron-down'}
        />
      </a>

      <div
        className={styles.detailContainer}
        style={{
          height: `${contentHeight}px`,
          transition: 'height 0.5s ease-in-out',
        }}>
        <div ref={detailsRef} className={styles.detailsContent}>
          {EstaticosData.map((cookie: Cookie, idx: number) => (
            <div key={idx} className={styles.col}>
              <div className={styles.row}>
                <div className={styles.cookie_name}>
                  <b>Nome:</b>
                </div>
                <span>{cookie.primeiroNome}</span>
              </div>
              <div className={styles.row}>
                <div className={styles.cookie_name}>
                  <b>Nome:</b>
                </div>
                <span>{cookie.segundoNome}</span>
              </div>
              <div className={styles.row}>
                <div className={styles.cookie_name}>
                  <b>Finalidade:</b>
                </div>
                <span>{cookie.finalidade}</span>
              </div>
              <div className={styles.row}>
                <div className={styles.cookie_name}>
                  <b>Validade:</b>
                </div>
                <span>{cookie.validade}</span>
              </div>
              <div className={styles.row}>
                <div className={styles.cookie_name}>
                  <b>Processador de Dados:</b>
                </div>
                <span>{cookie.processadorDados}</span>
              </div>
              <div className={styles.row}>
                <div className={styles.cookie_name}>
                  <b>Política de Privacidade do Processador de Dados:</b>
                </div>
                <a href={cookie.linkPolitica} rel="noreferrer" target="_blank">
                  {cookie.linkPolitica}
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Estatico
